import React, { useState, useEffect, useRef } from "react";
import { getMessageBoard } from "../../../actions/dashboardActionsPP";
import { useSelector, useDispatch } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import { Loader } from "cxa-components";
import Modal from "react-modal";
import messages from "components/messagesDescription";
import LeftIcon from "../../../assets/images/svg/ic_chevron_left_24px.svg";
import RightIcon from "../../../assets/images/svg/ic_chevron_right_24px.svg";

const MessageBoard = ({ intl }) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [autoScrollPaused, setAutoScrollPaused] = useState(false);
  const descriptionRef = useRef(null);

  const dispatch = useDispatch();

  const messageBoardData = useSelector(state => state.dashboardPP.messageBoardData);

  useEffect(() => {
    let timer;
    if (!autoScrollPaused) {
      timer = setTimeout(() => {
        goToNextMessage();
      }, 10000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [currentMessageIndex, messageBoardData, autoScrollPaused]);

  useEffect(() => {
    dispatch(getMessageBoard());
  }, []);

  useEffect(() => {
    checkOverflow();
  }, [currentMessageIndex, messageBoardData]);

  const checkOverflow = () => {
    if (descriptionRef.current) {
      // Add a small delay to ensure content (including images) has loaded
      setTimeout(() => {
        setIsOverflowing(descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight);
      }, 100);
    }
  };

  const goToPreviousMessage = () => {
    if (messageBoardData) {
      setCurrentMessageIndex(
        prevIndex => (prevIndex - 1 + messageBoardData.length) % messageBoardData.length
      );
    }
  };

  const goToNextMessage = () => {
    if (messageBoardData) {
      setCurrentMessageIndex(prevIndex => (prevIndex + 1) % messageBoardData.length);
    }
  };

  const handleDotClick = index => {
    setCurrentMessageIndex(index);
  };

  const handleReadMore = e => {
    e.preventDefault();
    setModalIsOpen(true);
    setAutoScrollPaused(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setAutoScrollPaused(false);
  };

  if (!messageBoardData) {
    return (
      <div className="container">
        <Loader />
      </div>
    );
  }

  const currentMessage = messageBoardData[currentMessageIndex];

  const MessageModal = (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      className="message-board-modal"
      overlayClassName="message-board-modal-overlay"
    >
      <button onClick={closeModal} className="link message-board-modal-close">
        &times;
      </button>
      <div>
        <h3>{currentMessage && currentMessage.messageTitle}</h3>
        <div
          className="message-board-modal-description"
          dangerouslySetInnerHTML={{ __html: currentMessage && currentMessage.messageDescription }}
        />
      </div>
    </Modal>
  );

  return messageBoardData.length > 0 ? (
    <div className="message-board-container tile-border">
      <h3>{intl.formatMessage(messages.messageBoardDescription)}</h3>
      <div className="message-content">
        <button className="message-board-icon" onClick={goToPreviousMessage}>
          <LeftIcon className="message-board-arrow-icon" />
        </button>

        <div className="message-description">
          <h3>
            {intl.formatMessage({
              id: currentMessage.messageTitle,
              defaultMessage: currentMessage.messageTitle,
            })}
          </h3>
          <div className="message-description-container">
            <p
              ref={descriptionRef}
              className="message-description-text"
              dangerouslySetInnerHTML={{
                __html: intl.formatMessage({
                  id: currentMessage.messageDescription,
                  defaultMessage: currentMessage.messageDescription,
                }),
              }}
            />
            {isOverflowing && (
              <button className="link read-more-link" onClick={handleReadMore}>
                {intl.formatMessage(messages.readMore)}
              </button>
            )}
          </div>
        </div>

        <button className="message-board-icon" onClick={goToNextMessage}>
          <RightIcon className="message-board-arrow-icon" />
        </button>
      </div>

      <div className="dot-container">
        {messageBoardData.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentMessageIndex ? "active-dot" : "inactive-dot"}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
      {MessageModal}
    </div>
  ) : null;
};

MessageBoard.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(MessageBoard);



// WEBPACK FOOTER //
// ./components/dashboard/DashboardNewUI/MessageBoardPP.js